import React from "react";
import { Grid, Hidden } from "@material-ui/core";
import DigitButton from "./DigitButton/DigitButton";
import { STDigitsWrapper, STTextField } from "./styles";
import { STPinButton } from "./DigitButton/styles";

import ClearIcon from "@material-ui/icons/Clear";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Values } from "@src/Tools/Values";
import { FormikProps, Field, FieldProps } from "formik";
import { IQuickLoginForm } from "../QuickLogin";
import { observer, inject } from "mobx-react";
import { IValuesStore } from "@src/Stores/Values/types";

interface IProps {
  formikProps: FormikProps<IQuickLoginForm>;
  values?: IValuesStore;
}

@inject("values")
@observer
export default class QuickLoginForm extends React.Component<IProps> {
  handlePinEnter = (digit: number) => {
    const value: string = this.props.formikProps.values.password;
    this.props.formikProps.setFieldValue("password", value + digit);
    this.sendRequestIfNeeded();
  };

  sendRequestIfNeeded = () => {
    setTimeout(() => {
      if (this.props.formikProps.values.password.length === 6) {
        this.props.formikProps.submitForm();
      }
    }, 1);
  };

  handleBackspace = () => {
    const value: string = this.props.formikProps.values.password;
    this.props.formikProps.setFieldValue("password", value.slice(0, -1));
  };

  handleClear = () => {
    this.props.formikProps.setFieldValue("password", "");
  };

  handleChange = (e: any) => {
    this.props.formikProps.setFieldValue("password", e.target.value);
    this.sendRequestIfNeeded();
  };

  render() {
    return (
      <Grid container direction="column" alignItems="center">
        <Grid item>
          <Hidden smUp>
            <Field
              name="password"
              render={(fieldProps: FieldProps) => (
                <STTextField
                  fullWidth
                  type="password"
                  {...fieldProps.field}
                  label={Values.getLocalizationValue("sixDigitCode")}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              )}
            />
          </Hidden>
          <Hidden xsDown>
            <Field
              name="password"
              render={(fieldProps: FieldProps) => (
                <STTextField
                  fullWidth
                  type="password"
                  {...fieldProps.field}
                  onChange={this.handleChange}
                  label={Values.getLocalizationValue("sixDigitCode")}
                />
              )}
            />
          </Hidden>
        </Grid>
        <STDigitsWrapper>
          <Grid item container justify="center" alignItems="stretch" spacing={1}>
            {new Array(9).fill(null).map((item: null, index: number) => (
              <Grid item key={index}>
                <DigitButton onClick={this.handlePinEnter} digit={index + 1} />
              </Grid>
            ))}
            <Grid item>
              <DigitButton digit={0} onClick={this.handlePinEnter} />
            </Grid>
            <Grid item>
              <STPinButton variant="outlined" fullWidth onClick={this.handleBackspace}>
                <ArrowBackIcon />
              </STPinButton>
            </Grid>
            <Grid item>
              <STPinButton variant="outlined" fullWidth onClick={this.handleClear}>
                <ClearIcon />
              </STPinButton>
            </Grid>
          </Grid>
        </STDigitsWrapper>
      </Grid>
    );
  }
}
